export const SPECS = {
  SendFullAddressOnExpressButtons: 'specs.stores.SendFullAddressOnExpressButtons',
  CheckoutFromSDKInExpressCheckoutButtons: 'specs.stores.CheckoutFromSDKInExpressCheckoutButtons',
  AddPoliciesToLineItems: 'specs.stores.AddPoliciesToLineItems'
};
//# sourceMappingURL=SPECS.js.map